import React from 'react';

const BOGOTA_TZ = 'America/Bogota';

const ventas30Tone = (n) => {
  const v = Number(n) || 0;
  if (v >= 5) return 'bg-emerald-50 text-emerald-800 border-emerald-200';
  if (v >= 1) return 'bg-amber-50 text-amber-800 border-amber-200';
  return 'bg-gray-50 text-gray-600 border-gray-200';
};

export const formatUltimaVentaSoloFecha = (fecha) => {
  if (!fecha) return 'Sin ventas';
  const d = new Date(fecha);
  if (Number.isNaN(d.getTime())) return 'Sin ventas';
  return d.toLocaleDateString('es-CO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: BOGOTA_TZ,
  });
};

const StatChip = ({ label, value, toneClass }) => (
  <div className={`flex flex-col items-center justify-center px-2 py-1.5 rounded-lg border text-center min-w-0 ${toneClass}`}>
    <span className="text-[10px] uppercase tracking-wide font-semibold opacity-80 truncate w-full">{label}</span>
    <span className="text-sm font-bold truncate w-full">{value}</span>
  </div>
);

const ProductSalesMetrics = ({ producto, compact = false }) => {
  const ventas30 = Number(producto.ventas_30_dias) || 0;
  const totalVentas = Number(producto.cantidad_ventas) || 0;
  const ultimaVenta = formatUltimaVentaSoloFecha(producto.fecha_ultima_venta);

  if (compact) {
    return (
      <div className="grid grid-cols-3 gap-1.5 mt-2">
        <StatChip label="30 días" value={ventas30} toneClass={ventas30Tone(ventas30)} />
        <StatChip label="Vendidos" value={totalVentas} toneClass="bg-slate-50 text-slate-700 border-slate-200" />
        <StatChip label="Última venta" value={ultimaVenta} toneClass="bg-slate-50 text-slate-700 border-slate-200" />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-2 mt-2">
      <StatChip label="30 días" value={ventas30} toneClass={ventas30Tone(ventas30)} />
      <StatChip label="Vendidos" value={totalVentas} toneClass="bg-slate-50 text-slate-700 border-slate-200" />
      <StatChip label="Última venta" value={ultimaVenta} toneClass="bg-slate-50 text-slate-700 border-slate-200" />
    </div>
  );
};

export default ProductSalesMetrics;
